import React from 'react';
import Nav from '../nav/index';
import navDetails from '../../config/nav';

export default function Header() {
	return (
		<>
			<Nav navDetails={navDetails()} />
		</>
	);
}
